import { ToastMode } from '../models/toastMode';
export const getToastPrimaryColor = (mode) => {
    if (mode === ToastMode.Success) {
        return 'positiveIcon';
    }
    if (mode === ToastMode.Error) {
        return 'dangerIcon';
    }
    return 'neutralIconStrong';
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29sb3JVdGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2NvbW1vbnMvQ2hvY29Ub2FzdC91dGlscy9jb2xvclV0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSxxQkFBcUIsQ0FBQztBQUVoRCxNQUFNLENBQUMsTUFBTSxvQkFBb0IsR0FBRyxDQUFDLElBQWUsRUFBb0IsRUFBRTtJQUN4RSxJQUFJLElBQUksS0FBSyxTQUFTLENBQUMsT0FBTyxFQUFFO1FBQzlCLE9BQU8sY0FBYyxDQUFDO0tBQ3ZCO0lBRUQsSUFBSSxJQUFJLEtBQUssU0FBUyxDQUFDLEtBQUssRUFBRTtRQUM1QixPQUFPLFlBQVksQ0FBQztLQUNyQjtJQUVELE9BQU8sbUJBQW1CLENBQUM7QUFDN0IsQ0FBQyxDQUFDIn0=